import React from 'react';
import { Link } from 'react-router-dom';
import './Home.css';

const Home = () => {
  const latestUpdates = [
    {
      title: 'New SEBI Regulations 2024',
      date: '15 January 2024',
      category: 'Regulatory Updates',
      description: 'SEBI introduces new compliance requirements for listed companies',
      icon: '📢'
    },
    {
      title: 'IBC Amendment Act',
      date: '10 January 2024',
      category: 'Legal Updates',
      description: 'Key changes in Insolvency and Bankruptcy Code implementation',
      icon: '⚖️'
    },
    {
      title: 'CSR Compliance Guidelines',
      date: '5 January 2024',
      category: 'Compliance',
      description: 'Updated guidelines for Corporate Social Responsibility spending',
      icon: '🤝'
    },
    {
      title: 'Digital Compliance Portal',
      date: '28 December 2023',
      category: 'Technology',
      description: 'Launch of new portal for streamlined regulatory filings',
      icon: '💻'
    }
  ];

  const coreAreas = [
    {
      title: 'Secretarial & Legal Compliance',
      icon: '📋',
      description: 'Comprehensive compliance services for corporate legal requirements'
    },
    {
      title: 'Audit & Due Diligence',
      icon: '🔍',
      description: 'Thorough audits and due diligence for informed decision making'
    },
    {
      title: 'Corporate Restructuring',
      icon: '🔄',
      description: 'Strategic restructuring services for business optimization'
    },
    {
      title: 'SEBI & Listed Entity Compliances',
      icon: '📊',
      description: 'Expert guidance on SEBI regulations and listed company compliances'
    },
    {
      title: 'Insolvency & Bankruptcy',
      icon: '⚖️',
      description: 'Professional services for IBC matters and resolution processes'
    },
    {
      title: 'Corporate Social Responsibility',
      icon: '🤝',
      description: 'CSR advisory and implementation services'
    }
  ];

  return (
    <div className="home">
      {/* Hero Section */}
      <section className="hero">
        <div className="container">
          <div className="hero-content">
            <h1 className="hero-title">Practical Wisdom, Trusted Advice</h1>
            <p className="hero-subtitle">
              About Carmanya
            </p>
            <p className="hero-description">
              We are one of the largest financial and company secretarial service providers. 
              Building strong and substantial client relationship is and will remain the 
              compass for our business strategy and future development.
            </p>
            <div className="hero-buttons">
              <Link to="/about" className="btn btn-primary">Learn More</Link>
              <Link to="/contact" className="btn btn-secondary">Contact Us</Link>
            </div>
          </div>
        </div>
      </section>

      {/* Latest Updates Section */}
      <section className="section latest-updates">
        <div className="container">
          <h2 className="section-title">Latest Updates</h2>
          <div className="updates-grid">
            {latestUpdates.map((update, index) => (
              <div key={index} className="update-card">
                <div className="update-icon">{update.icon}</div>
                <div className="update-content">
                  <div className="update-date">{update.date}</div>
                  <h3 className="update-title">{update.title}</h3>
                  <p className="update-description">{update.description}</p>
                  <span className="update-category">{update.category}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Core Areas Section */}
      <section className="section core-areas">
        <div className="container">
          <h2 className="section-title">Our Core Areas of Practice</h2>
          <div className="areas-grid">
            {coreAreas.map((area, index) => (
              <div key={index} className="area-card">
                <div className="area-icon">{area.icon}</div>
                <h3 className="area-title">{area.title}</h3>
                <p className="area-description">{area.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="section cta-section">
        <div className="container">
          <div className="cta-content">
            <h2>Ready to Get Started?</h2>
            <p>Contact us today for expert legal and advisory services</p>
            <Link to="/contact" className="btn btn-primary">Contact Us</Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;
